import Roles from 'spark-types/Roles';
import actionCreators from 'spark-state/actionCreators';
import get from 'lodash/get';
export const CHANGE_ENTERPRISE = 'USER.CHANGE_ENTERPRISE';
export const SET_CURRENT_ENTERPRISE = 'USER.SET_CURRENT_ENTERPRISE';
export const SET_CURRENT_ENTERPRISE_ROLE = 'USER.SET_CURRENT_ENTERPRISE_ROLE';
export const SET_DOMAIN_VALUE = 'USER.SET_DOMAIN_VALUE';
export const SET_CURRENT_USER_INFO = 'USER.SET_CURRENT_USER_INFO';
// SAF-20237: Role Assignment - Switch Roles and its Precedence - PSR-4763
// Store report access flag for recipient roles per enterprise
export const SET_REPORT_ENABLED_FOR_SPONSOR = 'USER.SET_REPORT_ENABLED_FOR_SPONSOR';
export const SET_REPORT_ENABLED_FOR_CRO = 'USER.SET_REPORT_ENABLED_FOR_CRO';
// SAF-18432-Safety - User Guide Integration- To set User Guides data in redux store
const SET_USER_GUIDES = 'USER.SET_USER_GUIDES';
/* export const SET_BULK_DOWNLOAD_STATUS = 'USER.SET_BULK_DOWNLOAD_STATUS';
export const SET_BULK_DOWNLOAD_RESULTS_GRID = 'USER.SET_BULK_DOWNLOAD_RESULTS_GRID';
export const SET_BULK_DOWNLOAD_SAFETY_NOTIFICATIONS = 'USER.SET_BULK_DOWNLOAD_SAFETY_NOTIFICATIONS'; */

const LOAD_USER_SETTINGS = 'USER.LOAD_USER_SETTINGS';
const SET_USER_INFO = 'USER.SET_USER_INFO';



export const loadingUserSettings = actionCreators.message(LOAD_USER_SETTINGS);

export const setUserInfo = (user = {}, role = '') => ({
	type: SET_USER_INFO,
	user,
	role
});

export const setCurrentEnterprise = (enterpriseId) => ({
	type: SET_CURRENT_ENTERPRISE,
	enterpriseId
});
export const setCurrentEnterpriseRole = (enterpriseRole) => ({
	type: SET_CURRENT_ENTERPRISE_ROLE,
	enterpriseRole
});
export const setDomainValue = (domainName, userInfo, isEntAutoEnabled) => ({
	type: SET_DOMAIN_VALUE,
	domainName,
	userInfo,
	isEntAutoEnabled
});
export const setCurrentUserInfo = (userInfo) => ({
	type: SET_CURRENT_USER_INFO,
	userInfo
});
// SAF-20237: Action to set report access flag based on active role's reportEnabledForSponsor property
export const setReportEnabledForSponsor = (enabled) => ({
	type: SET_REPORT_ENABLED_FOR_SPONSOR,
	enabled
});
// Action to set report access flag based on active role's reportEnabledForCRO property
export const setReportEnabledForCRO = (enabled) => ({
	type: SET_REPORT_ENABLED_FOR_CRO,
	enabled
});
// User Guides
export const setUserGuides = (response) => ({ type: SET_USER_GUIDES, response });
export const changeEnterprise = (enterpriseId) => ({
	type: CHANGE_ENTERPRISE,
	enterpriseId
});

export const userCurrentEnterprise = (state) => state.user.enterpriseId;
export const currentEnterpriseRole = (state) => state.user.enterpriseRole;
export const getUsername = (state) => state.user.name;
export const getPreferredUsername = (state) => state.user.preferred_username;
export const getUserRoles = (state) => state.user.roles;
export const getUserInfo = (state) => state.user;
export const currentUserInfo = (state) => state.user.userInfo;
export const getUserRolesFormatted = (state) => [ ...state.user.roles ].join();
export const userHasRole = (state, role) => state.user.roles.has(role);
export const isEnterpriseAdmin = (state) => state.user.isEnterpriseAdmin;
export const isRecipient = (state) => userHasRole(state, Roles.SAFETY_RECP) || userHasRole(state, Roles.GP_RECP) || userHasRole(state, Roles.IB_RECP);
export const isManagementUser = (state) =>
	state.user.roles.size > 0 &&
	[ Roles.SAFETY_ADMIN, Roles.SAFETY_MANAGER, Roles.SAFETY_MONITOR, Roles.COUNTRY_LEAD ].some((role) =>
		userHasRole(state, role)
	);

export const isSafetyAdmin = (state) =>
	state.user.roles.size > 0 && [ Roles.SAFETY_ADMIN ].some((role) => userHasRole(state, role));

export const isSafetyMonitorUser = (state) =>
	state.user.roles.size > 0 && [ Roles.SAFETY_MONITOR ].some((role) => userHasRole(state, role));

export const isSafetyAdminManager = (state) =>
	state.user.roles.size > 0 && [ Roles.SAFETY_ADMIN, Roles.SAFETY_MANAGER ].some((role) => userHasRole(state, role));

export const isCountryLead = (state) =>
	state.user.roles.size > 0 && [ Roles.COUNTRY_LEAD ].some((role) => userHasRole(state, role));

export const isIBCountryLead = (state) =>
	state.user.roles.size > 0 && [ Roles.IB_COUNTRY_LEAD ].some((role) => userHasRole(state, role));

// SAF-20491: Combined check for any support role (used for UI visibility like enterprise dropdown)
export const isSupportUser = (state) =>
	state.user.roles.size > 0 && [ Roles.SAFETY_SUPPORT, Roles.IB_SUPPORT, Roles.GAP_PACKET_SUPPORT ].some((role) => userHasRole(state, role));

// SAF-20491: Module-specific support selectors for routing each support role to its correct module
export const isSafetySupport = (state) =>
	state.user.roles.size > 0 && userHasRole(state, Roles.SAFETY_SUPPORT);

export const isIBSupport = (state) =>
	state.user.roles.size > 0 && userHasRole(state, Roles.IB_SUPPORT);

export const isGapPacketSupport = (state) =>
	state.user.roles.size > 0 && userHasRole(state, Roles.GAP_PACKET_SUPPORT);

export const isGapPacketAdmin = (state) =>
	state.user.roles.size > 0 && [ Roles.GAP_PACKET_ADMIN ].some((role) => userHasRole(state, role));
//export const isBulkDownloadComplete = (state) => state.user.isBulkDownloadComplete;

//SAF-17154 - IBAdmin and IB Country Lead role check
export const isIBManagementUser = (state) =>
	state.user.roles.size > 0 && [ Roles.IB_ADMIN, Roles.IB_COUNTRY_LEAD, Roles.IB_MONITOR ].some((role) => userHasRole(state, role));

//19117 Added IB Monitor role check
export const isIBMonitorUser = (state) =>
	state.user.roles.size > 0 && [ Roles.IB_MONITOR ].some((role) => userHasRole(state, role));

export const isSafetyRecipient = (state) =>
	state.user.roles.size > 0 && userHasRole(state, Roles.SAFETY_RECP);

export const isGapPacketRecipient = (state) =>
	state.user.roles.size > 0 && userHasRole(state, Roles.GP_RECP);

export const isIBRecipient = (state) =>
	state.user.roles.size > 0 && userHasRole(state, Roles.IB_RECP);

/**
 * Get the current active role code
 * Returns the role code stored in enterpriseRole, or falls back to roles Set
 */
export const getCurrentActiveRole = (state) => {
	return state.user.roles && state.user.roles.size > 0 ? Array.from(state.user.roles)[0] : null;
};

export const setReportingFlag = (state) => state.user.reportingFlag;
export const getIsEntAutoEnabled = (state) => state.user.isEntAutoEnabled;
// SAF-20237: Selector to get report access flag for current active recipient role
export const getReportEnabledForSponsor = (state) => state.user.reportEnabledForSponsor;
// Selector to get report access flag for CRO users
export const getReportEnabledForCRO = (state) => state.user.reportEnabledForCRO;

// SAF-18432-Safety - User Guide Integration- User Guides selector
export const getUserGuideById = (state, id) => get(state, 'user.userGuides', []).find(guide => guide.id === id);
//export const getBulkDownloadResultsGrid = (state) => state.user.displayBulkDownloadGrid;


// New: effective enterprise that respects explicit user selection
export const userCurrentEnterpriseEffective = (state) =>
	state.user.hasEnterpriseSelected ? state.user.enterpriseId : null;

const initialState = {
	name: '',
	isEnterpriseAdmin: false,
	roles: new Set(),
	userInfo: {},
	//isBulkDownloadComplete: false,
	reportingFlag: false,
	//displayBulkDownloadGrid: false
	isEntAutoEnabled: 'N',
	// SAF-20237: Flag to control report access for recipient roles
	reportEnabledForSponsor: false,
	// Flag to control report access for CRO users
	reportEnabledForCRO: false,
	enterpriseId: null,
	enterpriseRole: null,
	hasEnterpriseSelected: false,
	userGuides: []
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CURRENT_ENTERPRISE: {
			return {
				...state,
				enterpriseId: action.enterpriseId,
				hasEnterpriseSelected: true
			};
		}
		case SET_CURRENT_ENTERPRISE_ROLE: {
			return {
				...state,
				enterpriseRole: action.enterpriseRole
			};
		}
		case SET_DOMAIN_VALUE: {
			let hasDomainValue = false;
			let domainList = action.domainName &&  action.domainName.toUpperCase().split(',');
			domainList = domainList && domainList.map(s => s.trim());
			let domainVal = action.userInfo.email.substring(action.userInfo.email.lastIndexOf('@') + 1);
			if (domainVal && domainList && domainList.includes(domainVal.toUpperCase())) {
				hasDomainValue = true;
			}

			return {
				...state,
				reportingFlag: hasDomainValue,
				isEntAutoEnabled: action.isEntAutoEnabled
			};
		}
		case SET_CURRENT_USER_INFO: {
			return {
				...state,
				userInfo: action.userInfo
			};
		}
		case SET_USER_INFO: {
			const roles = new Set();
			if (action.user.isEnterpriseAdmin) {
				roles.add(Roles.ENTERPRISE_ADMIN);
			}
			action.role && roles.add(action.role);

			return {
				...state,
				...action.user,
				roles
			};
		}
		// SAF-20237: Update report access flag when role changes
		case SET_REPORT_ENABLED_FOR_SPONSOR: {
			return {
				...state,
				reportEnabledForSponsor: action.enabled
			};
		}
		// Update report access flag for CRO users
		case SET_REPORT_ENABLED_FOR_CRO: {
			return {
				...state,
				reportEnabledForCRO: action.enabled
			};
		}
		// SAF-18432-Safety - User Guide Integration- To set User Guides in redux store
		case SET_USER_GUIDES: {
			return {
				...state,
				userGuides: get(action.response, 'data', [])
			};
		}
		 /* case SET_BULK_DOWNLOAD_STATUS: {
			return {
				...state,
				isBulkDownloadComplete: action.bulkDownloadStatus
			};
		}
		case SET_BULK_DOWNLOAD_RESULTS_GRID: {
			return {
				...state,
				displayBulkDownloadGrid: action.status
			};
		}
		case SET_BULK_DOWNLOAD_SAFETY_NOTIFICATIONS: {
			return {
				...state,
			bulkDownloadSL: JsonFormatter.arrayToObject(
				'safetyId',
				get(action.response, 'data.content', [])			)
				
			};
		}  */
		default: {
			return state;
		}
	}
};
